import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { fetchGameCrashes } from '../../api/gameCrashes';

interface Props {
  open: boolean;
  gameId: string | null;
  gameName: string;
  onClose: () => void;
}

function fmtDate(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function CrashHistoryDialog({ open, gameId, gameName, onClose }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ['game-crashes', gameId],
    queryFn: () => fetchGameCrashes(gameId!),
    enabled: open && gameId !== null,
    staleTime: 30_000,
  });

  const crashes = data?.crashes ?? [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Absturz-Historie — {gameName}</DialogTitle>
      <DialogContent>
        {isLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress />
          </Box>
        )}
        {!isLoading && crashes.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            Keine Abstürze aufgezeichnet.
          </Typography>
        )}
        {!isLoading && crashes.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Zeitpunkt</TableCell>
                <TableCell align="right">Neustart #</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {crashes.map((c, i) => (
                <TableRow key={i}>
                  <TableCell>{fmtDate(c.ts)}</TableCell>
                  <TableCell align="right">{c.restart_count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}
